import Container from '@mui/material/Container'

import Heading from '~/client/components/Heading'

export default function PricingPage() {
  return <Container>
    <Heading my={4} variant="major">Pricing</Heading>
    <p>DataPal is dedicated to keeping you our one and only customer.</p>
    <p>We will never profit of selling your data.</p>
    <p>Pricing model coming soon…</p>
  </Container>
}
